var WHO_PUBLICATION_FIELDS, WHO_WORKSPACES;

WHO_WORKSPACES = ['o_test_-_who-magic-import_0', 'o_who_maternal_and_perinatal_health_recommendations_0', 'o_world_health_organization_who_0'];

WHO_PUBLICATION_FIELDS = [
  {
    fieldKey: 'byName',
    type: 'text'
  }, {
    fieldKey: 'contactAddress',
    type: 'text'
  }, {
    fieldKey: 'contactEmail',
    type: 'text'
  }, {
    fieldKey: 'contactName',
    type: 'text'
  }, {
    fieldKey: 'contactTelephone',
    type: 'text'
  }, {
    fieldKey: 'contactWeb',
    type: 'text'
  }, {
    fieldKey: 'countryFlag',
    type: 'text'
  }, {
    fieldKey: 'department',
    type: 'text'
  }, {
    fieldKey: 'disclaimer',
    type: 'editorText'
  }, {
    fieldKey: 'institutionLogoUrl',
    type: 'text'
  }, {
    fieldKey: 'institutionName',
    type: 'text'
  }, {
    fieldKey: 'institutionShortName',
    type: 'text'
  }, {
    fieldKey: 'issn',
    type: 'text'
  }, {
    fieldKey: 'language',
    type: 'text'
  }, {
    fieldKey: 'latestLiteratureSearchDate',
    type: 'text'
  }, {
    fieldKey: 'owner',
    type: 'text'
  }, {
    fieldKey: 'publishLastSearchDate',
    type: 'text'
  }, {
    fieldKey: 'versionMajor',
    type: 'text'
  }, {
    fieldKey: 'versionMinor',
    type: 'text'
  }
];

module.exports = {
  WHO_WORKSPACES: WHO_WORKSPACES,
  WHO_PUBLICATION_FIELDS: WHO_PUBLICATION_FIELDS
};
